import FoodTableChart from 'components/farm-dashboard/components/widgets/feed-availability/components/chart/FoodtableChart'

import ChartLegend from 'ui/charts/legends/ChartLegend'
import { ExpiredLicense } from 'ui/expired-license/ExpiredLicense'
import { BaseWidget } from '../baseWidget'
import { FoodTableChartHeader } from './components/food-table-chart-header/FoodTableChartHeader'
import { CHART_LEGENDS } from './constants/chart-legends'

export const FeedAvailabilityWidget = () => {
	const isExpired = false

	return (
		<BaseWidget
			title='Доступность корма'
			path={'analytics/feeding'}
			isLoading={false}
			pathLable='Перейти в аналитику кормления'
		>
			{isExpired ? (
				<ExpiredLicense mt={'120px'} />
			) : (
				<>
					<FoodTableChartHeader />
					<FoodTableChart />
					<ChartLegend initialLegends={CHART_LEGENDS} />{' '}
				</>
			)}
		</BaseWidget>
	)
}

export default FeedAvailabilityWidget
